import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let summaryCache = null;
let inflight = null;
const listeners = new Set();

async function fetchSummary() {
  if (summaryCache) return summaryCache;
  if (!inflight) {
    inflight = axios
      .get(`${API}/reviews/summary`)
      .then((r) => {
        summaryCache = r.data || {};
        return summaryCache;
      })
      .catch(() => {
        summaryCache = {};
        return summaryCache;
      });
  }
  return inflight;
}

export function invalidateReviewSummary() {
  summaryCache = null;
  inflight = null;
  listeners.forEach((l) => l());
}

export function useReviewSummary(productId) {
  const [summary, setSummary] = useState(() => (summaryCache && productId ? summaryCache[productId] : null));
  useEffect(() => {
    let cancelled = false;
    const apply = () => {
      const s = (summaryCache && productId) ? summaryCache[productId] || null : null;
      if (!cancelled) setSummary(s);
    };
    fetchSummary().then(apply);
    listeners.add(apply);
    return () => {
      cancelled = true;
      listeners.delete(apply);
    };
  }, [productId]);
  return summary; // null or { count, avg }
}
